// Central static data for Mrinmaya vacation home website

export const HOMESTAY = {
  name: "Mrinmaya",
  tagline: "Mountains, Movie Nights, Memories",
  location: "Chikkaballapura, near Nandi Hills, Karnataka",
  bedrooms: 3,
  beds: 6,
  sleeps: 12,
  pricing: {
    weekday: "₹9,000 + GST",
    weekend: "₹15,000 + GST",
    security_deposit: "₹3,000",
  },
  contact: {
    phone: "+916364900718",
    phoneDisplay: "+91 63649 00718",
    whatsapp: "916364900718",
    email: "mrinmaya.vacationhome@gmail.com",
    airbnb_url: "https://www.airbnb.co.in/rooms/1655846352932605660",
  },
};

export const GALLERY = [
  {
    url: "https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/5qfp59k3_PXL_20260402_124106762.MP~2.jpg",
    alt: "Corner bedroom with two large windows framing sunset and rocky hills",
    span: "tall",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/vdmwcr0t_PXL_20260402_124153721.MP~2.jpg",
    alt: "Bedroom with floor-to-ceiling windows overlooking sunrise over the hills",
    span: "wide",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/ucmog5bb_PXL_20260402_125725664.MP~2.jpg",
    alt: "Hammock swing beside the koi pond with a view of Nandi Hills",
    span: "normal",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/wgtij3s4_PXL_20260402_165449501.MP.jpg",
    alt: "Open-air projector movie night by the bonfire at Mrinmaya vacation home",
    span: "wide",
  },
  {
    url: "https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/7zdp9h5w_PXL_20260402_111955954~2.jpg",
    alt: "View from the rooftop of Mrinmaya vacation home — near Nandi Hills",
    span: "tall",
  },
];

export const AMENITIES = [
  { icon: "Projector", title: "Open-Air Projector", desc: "IPL, F1 & favourite films under the stars." },
  { icon: "Campfire", title: "Bonfire Pit", desc: "Crackling nights, warm conversations." },
  { icon: "Mountains", title: "Mountain views", desc: "Wake up to uninterrupted hill vistas." },
  { icon: "Grill", title: "Barbeque Grill", desc: "Grill-side evenings, smoky tikkas, crackling conversations." },
  { icon: "Drop", title: "Private Pond", desc: "A quiet corner for reflection." },
  { icon: "Cookie", title: "Fully-Stocked Kitchen", desc: "Cook up comfort food together." },
  { icon: "BedDouble", title: "3BR · Sleeps 12", desc: "Generous rooms, 6 beds, 1 hammock loft." },
  { icon: "SunHorizon", title: "Sunrise & Sunset", desc: "Golden hour windows on both ends." },
];

export const ALL_AMENITIES = [
  {
    category: "Bathroom",
    items: [
      "Hot water",
      "Body soap",
      "Shampoo",
      "Towels provided",
    ],
  },
  {
    category: "Bedroom & laundry",
    items: [
      "Linens",
      "Extra pillows & blankets",
      "Hangers",
      "Room-darkening curtains",
      "Washing machine",
    ],
  },
  {
    category: "Entertainment",
    items: [
      "Open-air HD projector",
      "IPL / sports screenings",
      "Bluetooth sound system",
      "Board games",
      "Books & reading corner",
      "Sports equipment",
    ],
  },
  {
    category: "Kitchen & dining",
    items: [
      "Fully-equipped kitchen",
      "Refrigerator",
      "Microwave",
      "Gas stove",
      // "Cooking basics (oil, salt, spices)",
      "Dishes & silverware",
      // "Coffee & tea",
      "Indoor dining table (4)",
      "Rooftop dining (8)",
    ],
  },
  {
    category: "Outdoor",
    items: [
      "Private rooftop terrace",
      "Bonfire pit",
      "Barbeque grill",
      "Outdoor dining area",
      "Private pond",
      "String-lit courtyard",
      "Garden",
    ],
  },
  {
    category: "Parking & facilities",
    items: [
      "Free parking on premises (4 cars)",
      "Wi-Fi (basic)",
    ],
  },
  {
    category: "Safety",
    items: [
      "First-aid kit",
      "Fire extinguisher",
    ],
  },
];

export const EXPERIENCES = [
  {
    title: "Nandi Hills Sunrise",
    distance: "15 min drive",
    image: "https://images.unsplash.com/photo-1506452305024-9d3f02d1c9b5?auto=format&fit=crop&w=1400&q=80",
    blurb: "The iconic cloud-sea sunrise, minutes from your doorstep.",
  },
  {
    title: "Skandagiri Night Trek",
    distance: "25 min drive",
    image: "https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1400&q=80",
    blurb: "Moonlit ridges and a sunrise above the clouds.",
  },
  {
    title: "Isha Foundation, Bangalore",
    distance: "45 min drive",
    image: "https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/6gnwz88y_Screenshot%202026-05-04%20at%202.21.28%20PM.png",
    blurb: "A serene visit to the Sadhguru Sannidhi — a must-watch light show at 7 PM everyday.",
  },
  {
    title: "Bhoga Nandishwara Temple",
    distance: "5 min drive",
    image: "https://customer-assets.emergentagent.com/job_cozy-nandi-escape/artifacts/0nffcyix_Screenshot%202026-05-04%20at%202.24.54%20PM.png",
    blurb: "9th-century stone architecture at the base of Nandi.",
  },
  {
    title: "Nandi Valley Vineyards",
    distance: "20 min drive",
    image: "https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?auto=format&fit=crop&w=1400&q=80",
    blurb: "Tastings in India’s wine country.",
  },
  {
    title: "Avalabetta Viewpoint",
    distance: "40 min drive",
    image: "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?auto=format&fit=crop&w=1400&q=80",
    blurb: "A lesser-known cliff with a dramatic drop.",
  },
];

export const REVIEWS = [
  {
    name: "Ananya S.",
    city: "Bangalore",
    stars: 5,
    quote:
      "The projector set-up in the courtyard made for an unforgettable IPL night. Sunrise from the balcony sealed the deal.",
  },
  {
    name: "Rohit & Meera",
    city: "Mumbai",
    stars: 5,
    quote:
      "Open-brick walls, a bonfire and a hammock loft — we didn’t want to leave. Hosts were super thoughtful.",
  },
  {
    name: "Kartik",
    city: "Hyderabad",
    stars: 5,
    quote:
      "Fit our gang of 11 comfortably. Perfect base for Skandagiri and Nandi Hills. Will be back.",
  },
];

export const BLOG_POSTS = [
  {
    slug: "nandi-hills-sunrise-guide",
    title: "The Complete Nandi Hills Sunrise Guide",
    excerpt:
      "Timings, entry fees, parking, the best viewpoints and exactly where to stand for that cloud-sea shot.",
    cover:
      "https://images.unsplash.com/photo-1506452305024-9d3f02d1c9b5?auto=format&fit=crop&w=1600&q=80",
    date: "Dec 2, 2025",
    readTime: "6 min read",
    tags: ["Nandi Hills", "Sunrise", "Weekend getaway"],
    content: [
      "Nandi Hills is that one sunrise spot near Bangalore that never gets old. Gates typically open at 6:00 AM and the drive from Mrinmaya takes a breezy 15–20 minutes — which means you can leave the blanket at 5:30 AM and still catch the horizon turning amber.",
      "Head to Tipu’s Drop for the widest frame, or walk the ridge along Nehru Nilaya for the classic cloud-sea shot. On post-monsoon mornings (Oct–Feb) the valley below Chikkaballapura fills like a bathtub of clouds.",
      "Entry is ₹10 per person, parking around ₹80 for a car. Carry a light jacket — even in summer, the breeze at the top feels 5° colder than the base.",
      "Back at Mrinmaya, a hot filter coffee on the verandah is the correct way to end a sunrise run.",
    ],
  },
  {
    slug: "ipl-screening-homestay-nandi-hills",
    title: "Why We Screen Every IPL Match Under the Stars",
    excerpt:
      "Nothing beats a wicket, a bonfire and a 120-inch screen in the open courtyard. Here’s how we set it up.",
    cover:
      "https://images.pexels.com/photos/34786572/pexels-photo-34786572.jpeg?auto=compress&cs=tinysrgb&w=1600",
    date: "Nov 28, 2025",
    readTime: "4 min read",
    tags: ["IPL", "Movie Nights", "Group Stay"],
    content: [
      "Cricket was always meant to be watched together. At Mrinmaya, we set up a 4K projector against a white-washed courtyard wall, wire in a full sound-bar, and let the bonfire handle the mood.",
      "Most IPL evenings kick off at 7:30 PM — which is also the golden hour light hitting our open-brick façade. We usually queue up the toss on the projector by 7:15 PM",
    ],
  },
  {
    slug: "weekend-getaway-from-bangalore-plan",
    title: "A 48-Hour Weekend Getaway Plan from Bangalore",
    excerpt:
      "Leave Friday night, be back Sunday night, and still feel properly rested. A Mrinmaya-tested itinerary.",
    cover:
      "https://images.unsplash.com/photo-1501854140801-50d01698950b?auto=format&fit=crop&w=1600&q=80",
    date: "Nov 19, 2025",
    readTime: "5 min read",
    tags: ["Weekend getaway", "Itinerary", "Bangalore"],
    content: [
      "Friday: Leave Hebbal by 8 PM — you’ll be at Mrinmaya by 9:30 PM. Bonfire, slow dinner, a film on the projector.",
      "Saturday: 5:30 AM Nandi Hills sunrise. Brunch back at the homestay. Afternoon pool/hammock/book. Evening — Skandagiri viewpoint drive and vineyard tasting at Grover Zampa.",
      "Sunday: Bhoga Nandishwara Temple at 7 AM (before it gets hot), lazy breakfast, back on the road by 1 PM. Traffic-free return.",
    ],
  },
];
